export enum NotificationActionTypes {
	ADD_NOTIFICATION = 'ADD_NOTIFICATION',
	REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
}